"use client";

import BFLLink from "@repo/shared-ui/BFLLink";
import { handleHeaderRewardsClickDL } from "./HeaderAnalyticsFunction";

interface HeaderPrimeProps {
  headerPrime?: {
    ctaText?: string;
    ctaLink?: string;
  };
}

const Prime: React.FC<HeaderPrimeProps> = ({ headerPrime }) => {
  const destinationUrl = headerPrime?.ctaLink || "";
  const ctaText = headerPrime?.ctaText || "Prime";

  const handleClick = () => {
    handleHeaderRewardsClickDL(destinationUrl, ctaText);
  };

  return (
    <BFLLink
      href={destinationUrl}
      onClick={handleClick}
      className="relative order-4 mx-0 my-0 flex flex-col items-center px-2 pb-[30px] pt-5 hover:bg-[#001326] md:order-5 md:min-h-[37px]"
    >
      <i className="icomoon text-xl before:content-['\e93c']"></i>
      <span className="absolute right-[0px] top-[20px] h-[8px] w-[8px] rounded-full bg-[#E8B100]"></span>
      <span className="hidden text-xs leading-[14px] md:!block">{ctaText}</span>
    </BFLLink>
  );
};
export default Prime;
